import RoomTypeDatalistPage from "pages/accommodation/roomTypes/RoomTypeDatalistPage";
import RoomDatalistPage from "pages/accommodation/rooms/RoomDatalistPage";

const RoomAndRoomTypeSettingsPage = () => {
    return (
        <div>
            <div>
                <RoomTypeDatalistPage />
            </div>
            <div className="my-10 border-b theme-border border-dashed"></div>
            <div>
                <RoomDatalistPage />
            </div>
        </div>
    );
};

export default RoomAndRoomTypeSettingsPage;
